var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard6C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type4_x5F_beards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M360.4,375.5c-1.4,0-12,0.7-8.5,3.7c1.6,1.4,3.4,2.3,4.9,3.9c0.8,0.8,1.4,1.8,2,2.7 c0.5,0.8,0.2,2.4,1.1,2.7c1.3,0.5,2.9-3.7,3.7-4.8c1.3-1.8,2.7-3,4.2-4.4c2.3-2.1,0.4-2.4-1.7-3 C364.2,375.9,362.4,375.6,360.4,375.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M305.1,351.1c1.3,0.2,4.5-1.4,5.7-1.7c2.3-0.8,4.7-1.4,7.1-2c9.1-2.4,17.8-3.6,27.4-2.7 c5.3,0.5,10.5,2.7,15.9,2.5c5.5,0.2,10.6-2,15.9-2.5c9.5-0.9,18.2,0.3,27.4,2.7c2.4,0.6,4.8,1.2,7.1,2c1.1,0.4,4.4,1.9,5.7,1.7 c1.4-0.2-2.4-7-5.6-8.5c-8.2-4-18.6-4-26.9-5.8c-2-0.4-4.3-1.1-6.1-2c-2.4-1.2-2.6-1.3-5-0.3c-4.2,1.8-7.9,2.9-12.6,3 c-4.7-0.2-8.4-1.2-12.6-3c-2.4-1.1-2.5-1-5,0.3c-1.8,0.9-4.1,1.6-6.1,2c-8.3,1.8-18.7,1.8-26.9,5.8 C307.5,344.2,303.7,351,305.1,351.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEA65F",
    d: "M452.2,267.2c-2.3,19-2.8,35.1-12.1,54.3c-2.4,6.1-6.6,10.5-11.2,15.2c-2.4,4.1-5,9.5-6.3,14.1 c-2.7,9.6-9.4,15.2-17,20.7c-14.4,10.6-27.6,22-45.3,23.1c-0.5,0-1,0-1.4,0c-0.1,0-0.3,0-0.5,0c-18.5-0.2-31.3-12.5-45.9-23.2 c-7.6-5.6-14.3-11.1-17-20.7c-1.3-4.6-3.9-10-6.3-14.1c-4.6-4.7-8.8-9-11.2-15.2c-9.4-19.2-6.9-35.8-12.5-53.6 c-1.2,11.7-3.4,22.4-2.7,35.7c0.2,3.2,2.3,14.9,2.7,17.3c2.9,13.8,4.2,14.7,9.3,27.5c2.5,6.1,7,11.6,10.6,16.9 c3.7,5.3,6.9,9.2,12.1,15.2c4.6,4,7.7,7.7,12.3,11.7c5.5,4.8,8.7,7.1,13.5,10.8c9.5,7.3,23.8,14.9,35.6,15.6c0.1,0,0.5,0,0.8,0 l0,0c0.1,0,0.2,0,0.3,0s0.2,0,0.3,0l0,0c0.3,0,0.7,0,0.8,0c11.7-0.6,22.4-8,31.8-15.4c4.8-3.8,10.6-8.5,15.5-12.2 c4.8-3.7,7.7-7.1,12.3-11.2c5.3-4.1,9.6-8.9,13.3-14.2c3.7-5.3,6.6-11.1,9.1-17.2c9.3-22.8,15.9-35.1,10.7-72 C453.5,273.3,452.9,270.4,452.2,267.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard6C);
export default __webpack_public_path__ + "static/media/man_beard_6c.dac4ba0d4cc456ac7f4a0c82ee341094.svg";
export { ForwardRef as ReactComponent };